import {
  IAddSocialMediaToBriefParams,
  IParseCreatorsGoogleSheetRequest,
} from "@shared/lib/types/brief";
import {
  IBriefDeliverable,
  IBriefDeliverableResponse,
  IFieldConfig,
} from "@shared/lib/types/briefInfluencerV2";

export function getGoogleSheetUrl(sheetId: string) {
  return `https://docs.google.com/spreadsheets/d/${sheetId}`;
}

export function isProcessedCreatorRow(
  row: IParseCreatorsGoogleSheetRequest
): boolean {
  return row.status === "success";
}

export function formatCommercial(value?: number) {
  if (value == null || Number.isNaN(Number(value))) {
    return "—";
  }
  return `₹${Number(value).toLocaleString("en-IN")}`;
}

export function toAddSocialMediaParams(
  row: IParseCreatorsGoogleSheetRequest
): IAddSocialMediaToBriefParams {
  return {
    socialMediaObjectId: row.socialMediaObjectId,
    link: row.link,
    platform: row.platform,
    username: row.username,
    editedDataFields: row.editedDataFields,
    deliverablesV2Id: row.deliverablesV2Id,
    influencerCost: row.influencerCost,
    brandCost: row.brandCost,
  };
}

export function getCreatorHandle(row: { username?: string }) {
  if (!row.username) return "—";
  return `@${row.username.replace(/^@/, "")}`;
}

function normalizeFieldKey(value?: string) {
  return value?.trim().toLowerCase() ?? "";
}

export function getCustomColumnName(
  fieldKey: string,
  customFields: IFieldConfig[]
): string {
  const normalized = normalizeFieldKey(fieldKey);
  const match = customFields.find((field) => {
    return normalizeFieldKey(field.key) === normalized;
  });
  return match?.displayName || match?.key || fieldKey;
}

export function collectCustomFields(groups: IFieldConfig[][]): IFieldConfig[] {
  const seen = new Set<string>();
  return groups.flat().filter((field) => {
    const id = field._id || field.key;
    if (!id || seen.has(id)) return false;
    seen.add(id);
    return true;
  });
}

export function findBriefDeliverable(
  deliverableV2Id: string | undefined,
  deliverables: IBriefDeliverableResponse[] = []
): IBriefDeliverable | undefined {
  if (!deliverableV2Id) return undefined;
  const id = String(deliverableV2Id).trim();
  if (!id) return undefined;

  return deliverables.find((item) => {
    const deliverableId = item.deliverableV2?._id;
    return deliverableId != null && String(deliverableId) === id;
  })?.deliverableV2;
}

export function getExtraFieldEntries(
  row: IParseCreatorsGoogleSheetRequest,
  customFields: IFieldConfig[] = []
): { key: string; value: string }[] {
  return Object.entries(row.editedDataFields ?? {}).map(([key, value]) => ({
    key: getCustomColumnName(key, customFields),
    value: String(value),
  }));
}
